export const language: any = {
    LabelLogin: "लॉगिन करें",
    LabelForgotPw: "पासवर्ड खोजें",
    LabelSignUp: "सदस्यता लें",
    LabelRememberMe: "लॉग इन रखें",
    Or: "या",
    Email: "ईमेल",
    Password: "पासवर्ड",
    LangKo: "कोरियाई",
    LangEn: "अंग्रेज़ी",
    LangVi: "वियतनामी",
    LabelCondition: "नियम और शर्तों से सहमत हैं",
    FullAgreement: "पूरी तरह से सहमत",
    Next: "आगे बढ़ें",
    PrivacyPolicy: `गोपनीयता नीति <span class="text-[#ff6741]">(आवश्यक)</span>`,
    TermOfUse: `उपयोग की शर्तें <label class="text-[#ff6741]">(आवश्यक)</label>`,
    VerifyPassword: "पासवर्ड सत्यापित करें",
    PlaceHolderPassword: "कम से कम 8 अक्षर + संख्याएं + विशेष वर्ण दर्ज करें",
    DuplicateCheck: "डुप्लिकेट जांच",
    LabelIdEmail: "आईडी (ईमेल)",
    GN_02_MSG_01: "आपका ऐप संस्करण पुराना हो चुका है। कृपया जारी रखने के लिए अपडेट करें।",
    AU_02_MSG_02: "यह ईमेल पहले से पंजीकृत है, कृपया दूसरा ईमेल इस्तेमाल करें।",
    AU_02_MSG_03: "यह ईमेल उपलब्ध है।",
    AU_02_MSG_01: "कृपया सही ईमेल प्रारूप दर्ज करें।",
    AU_01_MSG_01: "गलत आईडी या पासवर्ड। कृपया पुनः प्रयास करें।",
    AU_02_MSG_04: "कृपया उपलब्ध ईमेल की पुष्टि करें।",
    AU_02_MSG_05: "कृपया कम से कम 8 अक्षरों, संख्याओं और विशेष वर्णों वाला पासवर्ड दर्ज करें।",
    AU_02_MSG_06: "पासवर्ड पुष्टिकरण मेल नहीं खाता।",
    AU_03_MSG_01: "कृपया मान्य ईमेल प्रारूप दर्ज करें।",
    AU_03_MSG_02: "यह ईमेल सिस्टम में पंजीकृत नहीं है।",
    AU_03_MSG_04: "※ एक सत्यापन कोड आपके पंजीकृत ईमेल पर भेजा गया है।",
    LabelRegisterComplete: "सदस्यता पंजीकरण पूरा हुआ!",
    LabelLoginToUseService: "लॉगिन करें और सेवा का उपयोग करें।",
    LabelDontRememberPassword: "क्या आप पासवर्ड भूल गए?",
    LabelYouCanFindEmail: "आप इसे ईमेल सत्यापन के माध्यम से पा सकते हैं।",
    LabelPasswordTemporarySendToEmail: "※ एक अस्थायी पासवर्ड आपके पंजीकृत ईमेल पर भेजा जाएगा।",
    SendVerifyNumber: "सत्यापन कोड भेजें",
    LabelCheckYourEmailForTemporaryPassword: "कृपया अस्थायी पासवर्ड के लिए अपना ईमेल जांचें।",
    PlaceHolderTemporaryPassword: "अस्थायी पासवर्ड दर्ज करें",
    LabelTemporaryPassword: "अस्थायी पासवर्ड",
    LabelDidntReceiveYourPassword: "क्या आपको अपना पासवर्ड नहीं मिला?",
    LabelYouCanResendItAfter: "आप इसे पुनः भेज सकते हैं",
    LabelYouCanResendAgain: "आप इसे फिर से भेज सकते हैं।",
    Confirm: "जांचें",
    Resend: "फिर से भेजें",
    LabelResetPassword: "पासवर्ड रीसेट करें",
    NewPassword: "नया पासवर्ड",
    ConfirmNewPassword: "पासवर्ड सत्यापित करें",
    PlaceHolderConfirmPassword: "पासवर्ड की पुष्टि करें",
    CurrentPassword: "वर्तमान पासवर्ड",
    LanguageSetting: "भाषा सेटिंग",
    LeaveMembership: "सदस्यता समाप्त करें",
    LabelConfirmPasswordToLeaveMemberShip: "कृपया अपनी सदस्यता समाप्त करने के लिए अपना पासवर्ड जांचें।",
    LabelConfirmPasswordMeansYouAgreeAllContent: "पासवर्ड की पुष्टि का अर्थ है कि आपने सभी निर्देशों को पढ़ा और स्वीकार किया है।",
    LabelCancelMembership: "सदस्यता रद्द करें",
    LabelBeforeLeaveYouCheckedContent: "निकासी से पहले, आपको नीचे दिए गए निर्देशों को पढ़ना और स्वीकार करना होगा।",
    LabelAfterLeaveAllInfoWillRemove: "निकासी के बाद, सभी सदस्य जानकारी और उपयोग रिकॉर्ड हटा दिए जाएंगे और उन्हें पुनर्प्राप्त नहीं किया जा सकता।",
    LabelIHaveReadAndAgreeContent: "मैंने सभी निर्देश पढ़ लिए हैं और सहमत हूँ।",
    ToUnsubscribe: "सदस्यता समाप्त करें",
    LabelWouldYouWantLogout: "क्या आप लॉगआउट करना चाहते हैं?",
    ChangePassword: "पासवर्ड बदलें",
    Menu: "मेनू",
    MenuLanguageSettings: "भाषा सेटिंग्स",
    MenuPrivacyPolicy: "गोपनीयता नीति",
    MenuLogout: "लॉगआउट",
    MenuLeaveMembership: "सदस्यता समाप्त करें",
    LabelAreYouSureLeaveMembership: "क्या आप वाकई सदस्यता समाप्त करना चाहते हैं?",
    LabelIfLeaveMembershipAllInfoWillRemove: "यदि आप सदस्यता समाप्त करते हैं, तो आपकी सभी जानकारी हटा दी जाएगी और पुनर्प्राप्त नहीं की जा सकती।",
    LabelPrivacyPolicy: "गोपनीयता नीति",
    LabelTermOfUse: "उपयोग की शर्तें",
    MI_02_MSG_01: "आपका वर्तमान पासवर्ड गलत है।",
    LabelModalLogin: "इस सुविधा का उपयोग करने के लिए लॉगिन या साइन अप करें।",
    LabelIdLogin: "आईडी लॉगिन",
    LabelSnsApple: "Apple के साथ जारी रखें",
    LabelSnsFacebook: "Facebook के साथ जारी रखें",
    LabelSnsGoogle: "Google के साथ जारी रखें",
    LabelItemLogin: "Hey!Cooker की विभिन्न सुविधाओं का अन्वेषण करने के लिए लॉगिन या साइन अप करें।",
    LabelSnsEmail: "ईमेल लॉगिन",
    LoadingLogin: "कृपया एक क्षण प्रतीक्षा करें।",
    MenuNotificationSettings: "सूचना सेटिंग्स",
  };
  